import {EventsHttp} from "../../../http/events";
import {NotesHttp} from "../../../http/notes";

export default {
    async setEvents({commit}) {
        const events = await EventsHttp.getAllEvents();
        commit('setEvents', events);
    },
    async setNotes({commit}) {
        const notes = await NotesHttp.getAllNotes();
        commit('setNotes', notes);
    },
    setQbToken({commit}, token) {
        commit('setQbToken', token);
    },
    setQbRefreshToken({commit}, token) {
        commit('setQbRefreshToken', token);
    },
    setManageEventDialog({commit}, status) {
        commit('setManageEventDialog', status);
    },
    setManageNoteDialog({commit}, status) {
        commit('setManageNoteDialog', status);
    }
}
